export const storeAssets = {
  logoVinci: "/store/logo-vinci.svg",
  productBottles: "/store/product-bottles.webp",
  heroSlide: "/store/eu/home-page-slide-1.png",
  benefitGlobal: "/store/eu/grid1.svg",
  benefitSatisfaction: "/store/eu/grid2.svg",
  benefitClinic: "/store/eu/grid3.svg",
  benefitShipping: "/store/eu/grid4.svg",
  beforeAfter1: "/store/eu/baa_1.jpg",
  beforeAfter2: "/store/eu/baa_2.jpg",
  beforeAfter3: "/store/eu/baa_3.jpg",
  beforeAfter4: "/store/eu/baa_4.jpg",
  beforeAfter5: "/store/eu/baa_5.jpg",
  beforeAfter6: "/store/eu/baa_6.jpg",
} as const;
